/* ============================================================
   LONGEVA RESEARCH BIOLOGICS — theme scripts
   Vanilla JS. Sin dependencias externas.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    try {
      return (cents / 100).toLocaleString('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 });
    } catch (e) { return '$' + Math.round(cents / 100); }
  };

  /* ---------- Analytics: capa neutral (no duplica los eventos nativos) ---------- */
  function track(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload || {}));
  }

  /* ---------- Foco atrapado en diálogos ---------- */
  var lastFocus = null;
  function openDialog(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, [href], input, select, textarea');
    if (f) f.focus();
  }
  function closeDialog(el) {
    if (!el) return;
    el.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [$('#RuoModal'), $('#CartDrawer'), $('#MobileNav')].forEach(function (d) {
      if (!d || d.hidden) return;
      // El aviso de acceso no se cierra sin aceptar
      if (d.id === 'RuoModal' && ruoEntryMode) return;
      closeDialog(d);
    });
  });

  /* ---------- Nav móvil ---------- */
  var mnav = $('#MobileNav');
  $$('[data-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-expanded', 'true'); openDialog(mnav); });
  });
  $$('[data-nav-close]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = $('[data-nav-open]'); if (t) t.setAttribute('aria-expanded', 'false');
      closeDialog(mnav);
    });
  });

  /* ---------- Galería de producto ---------- */
  (function gallery() {
    var main = $('#GalMain');
    if (!main) return;
    $$('.gal__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-gal-src');
        if (src) { main.src = src; main.removeAttribute('srcset'); }
        $$('.gal__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  })();

  /* ---------- Selector de cantidad ---------- */
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = $('#Qty');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = Math.max(1, v + parseInt(b.getAttribute('data-qty'), 10));
      input.value = v;
    });
  });

  /* ---------- "Leer más" ---------- */
  $$('[data-clamp]').forEach(function (el) {
    if (el.scrollHeight <= 170) return;
    el.classList.add('is-clamped');
    var btn = el.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var clamped = el.classList.toggle('is-clamped');
      btn.textContent = clamped ? 'Leer más' : 'Leer menos';
    });
  });

  /* ---------- Confirmación RUO ---------- */
  var RUO_KEY = 'longeva_ruo_ack';
  function ruoConfig() { return window.LONGEVA_RUO || { enabled: false, days: 0 }; }

  function ruoAccepted() {
    var cfg = ruoConfig();
    if (!cfg.enabled) return true;
    if (!cfg.days) return false;
    try {
      var ts = parseInt(localStorage.getItem(RUO_KEY), 10);
      if (!ts) return false;
      return (Date.now() - ts) < cfg.days * 86400000;
    } catch (e) { return false; }
  }

  function ruoRemember() {
    var cfg = ruoConfig();
    if (!cfg.days) return;
    try { localStorage.setItem(RUO_KEY, String(Date.now())); } catch (e) {}
  }

  var pendingAction = null;
  var ruoEntryMode = false;

  function requireRuo(action) {
    if (ruoAccepted()) { action(); return; }
    var cfg = ruoConfig();
    // En modo "solo al entrar", la compra no vuelve a pedir confirmación
    if (cfg.trigger === 'entry') { action(); return; }
    var modal = $('#RuoModal');
    if (!modal) { action(); return; }
    ruoEntryMode = false;
    pendingAction = action;
    $$('[data-ruo-check]', modal).forEach(function (c) { c.checked = false; });
    var cont = $('[data-ruo-continue]', modal);
    if (cont) cont.disabled = true;
    var cancel = $('[data-ruo-cancelbtn]', modal);
    if (cancel) cancel.hidden = false;
    openDialog(modal);
  }

  /* Aviso de acceso al entrar al sitio */
  (function ruoEntryGate() {
    var cfg = ruoConfig();
    if (!cfg.enabled) return;
    if (cfg.trigger !== 'entry' && cfg.trigger !== 'both') return;
    if (ruoAccepted()) return;
    var modal = $('#RuoModal');
    if (!modal) return;
    ruoEntryMode = true;
    pendingAction = null;
    var cancel = $('[data-ruo-cancelbtn]', modal);
    if (cancel) cancel.hidden = true;   // es una puerta de acceso, no un diálogo opcional
    openDialog(modal);
  })();

  (function ruoWire() {
    var modal = $('#RuoModal');
    if (!modal) return;
    var checks = $$('[data-ruo-check]', modal);
    var cont = $('[data-ruo-continue]', modal);
    if (!checks.length || !cont) return;

    function sync() {
      var all = true;
      for (var i = 0; i < checks.length; i++) { if (!checks[i].checked) { all = false; break; } }
      cont.disabled = !all;
    }
    checks.forEach(function (c) {
      c.addEventListener('change', sync);
      c.addEventListener('click', sync);
    });
    sync();

    cont.addEventListener('click', function () {
      if (cont.disabled) return;
      ruoRemember();
      track('ruo_confirmed', {});
      ruoEntryMode = false;
      closeDialog(modal);
      var a = pendingAction; pendingAction = null;
      if (a) a();
    });
    $$('[data-ruo-cancel]', modal).forEach(function (b) {
      b.addEventListener('click', function () {
        if (ruoEntryMode) return;
        pendingAction = null;
        closeDialog(modal);
      });
    });
  })();

  /* ---------- Carrito ---------- */
  var drawer = $('#CartDrawer');
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () { renderCart(); openDialog(drawer); track('view_cart', {}); });
  });
  $$('[data-cart-close]').forEach(function (b) {
    b.addEventListener('click', function () { closeDialog(drawer); });
  });

  function updateCount(n) {
    var el = $('[data-cart-count]');
    if (!el) return;
    el.textContent = n;
    el.hidden = n === 0;
  }

  function renderCart() {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (!body) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!cart.items.length) {
          body.innerHTML = '<p class="drawer__empty">Tu carrito está vacío</p>';
          if (foot) foot.hidden = true;
          return;
        }
        body.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img src="' + it.image.replace(/(\.[^.]*)$/, '_120x$1') + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>';
          return '<div class="dline">' + img +
            '<div><a class="dline__t" href="' + it.url + '">' + it.product_title + '</a>' +
            '<span class="dline__m">' + (it.variant_title && it.variant_title.indexOf('Default') === -1 ? it.variant_title + ' · ' : '') + 'Cantidad: ' + it.quantity + '</span>' +
            '<button class="dline__x" data-remove="' + it.key + '">Quitar</button></div>' +
            '<strong>' + money(it.final_line_price) + '</strong></div>';
        }).join('');
        var sub = $('[data-cart-subtotal]');
        if (sub) sub.textContent = money(cart.total_price);
        if (foot) foot.hidden = false;
        $$('[data-remove]', body).forEach(function (b) {
          b.addEventListener('click', function () {
            changeLine(b.getAttribute('data-remove'), 0);
          });
        });
      })
      .catch(function () {});
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { track('remove_from_cart', {}); renderCart(); }).catch(function () {});
  }

  function addToCart(form, then) {
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (item) {
        track('add_to_cart', { item_name: item.product_title, value: item.final_price / 100, currency: 'MXN' });
        if (window.fbq) window.fbq('track', 'AddToCart', { content_name: item.product_title, value: item.final_price / 100, currency: 'MXN' });
        if (then) { then(); return; }
        renderCart();
        openDialog(drawer);
      })
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : 'No se pudo agregar al carrito. Intenta de nuevo.';
        alert(msg);
      });
  }

  (function productForm() {
    var form = $('#ProductForm');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      requireRuo(function () { addToCart(form); });
    });

    var buy = $('[data-buy-now]');
    if (buy) {
      buy.addEventListener('click', function () {
        requireRuo(function () {
          addToCart(form, function () {
            track('begin_checkout', {});
            window.location.href = '/checkout';
          });
        });
      });
    }

    var sticky = $('[data-sticky-add]');
    if (sticky) {
      sticky.addEventListener('click', function () {
        requireRuo(function () { addToCart(form); });
      });
    }
  })();

  /* ---------- Sticky CTA móvil ---------- */
  (function stickyCta() {
    var bar = $('#StickyCta');
    var cta = $('[data-add-to-cart]');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { threshold: 0 }).observe(cta);
  })();

  /* ---------- Eventos declarativos ---------- */
  $$('[data-evt]').forEach(function (el) {
    var name = el.getAttribute('data-evt');
    if (name === 'view_item' || name === 'view_item_list') {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          track(name, { list_name: el.getAttribute('data-list-name') || '' });
          io.disconnect();
        }
      }, { threshold: 0.25 });
      io.observe(el);
    } else {
      el.addEventListener('click', function () {
        track(name, { doc_type: el.getAttribute('data-doc-type') || '' });
      });
    }
  });

  /* ---------- Estado inicial del contador ---------- */
  if ($('[data-cart-count]')) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCount(c.item_count); })
      .catch(function () {});
  }
})();
